module.exports = __webpack_public_path__ + "img/icon_request_tech_assistance_services.5bedef60.svg";